import moment from "moment";
import { DIAS } from "../consts";
import { monthKey, getDiasDelMes } from "../utils/fechas";

// Modelo de celda-día: { codigo: "M" | "T" | "N" | "", observacion: "" }.
// Un solo valor por día: M=Mañana, T=Tarde, N=Noche, F=Franco, L=Licencia.
// La observación es del día. Celda sin datos: código vacío.
const dia = (codigo) => ({ codigo, observacion: "" });
const franco = () => ({ codigo: "F", observacion: "" });

// Patrón semanal base por empleado; empleadosHorariosGet lo expande sobre las fechas
// reales del mes pedido. Reemplazar por el service real cuando exista.
export const empleadosHorariosMock = [
    {
        id: 1,
        empleado: "Juan Pérez",
        lunes: dia("M"),
        martes: dia("M"),
        miercoles: franco(),
        jueves: dia("M"),
        viernes: dia("M"),
        sabado: franco(),
        domingo: franco(),
    },
    {
        id: 2,
        empleado: "María Gómez",
        lunes: dia("T"),
        martes: franco(),
        miercoles: dia("T"),
        jueves: franco(),
        viernes: dia("T"),
        sabado: franco(),
        domingo: dia("M"),
    },
    {
        id: 3,
        empleado: "Carlos Fernández",
        lunes: dia("M"),
        martes: dia("M"),
        miercoles: dia("M"),
        jueves: dia("M"),
        viernes: dia("M"),
        sabado: dia("M"),
        domingo: dia("M"),
    },
    {
        id: 4,
        empleado: "Ana Rodríguez",
        lunes: franco(),
        martes: franco(),
        miercoles: franco(),
        jueves: franco(),
        viernes: franco(),
        sabado: franco(),
        domingo: franco(),
    },
    {
        id: 5,
        empleado: "Lucía Sosa",
        lunes: dia("M"),
        martes: dia("M"),
        miercoles: franco(),
        jueves: dia("M"),
        viernes: franco(),
        sabado: franco(),
        domingo: franco(),
    },
    {
        id: 6,
        empleado: "Diego Álvarez",
        // Rotación de turnos a lo largo de la semana.
        lunes: dia("N"),
        martes: dia("T"),
        miercoles: dia("T"),
        jueves: franco(),
        viernes: franco(),
        sabado: dia("N"),
        domingo: dia("N"),
    },
    {
        id: 7,
        empleado: "Rosa Medina",
        lunes: dia("M"),
        martes: dia("M"),
        miercoles: dia("M"),
        jueves: dia("M"),
        viernes: dia("M"),
        sabado: franco(),
        domingo: franco(),
    },
    {
        id: 8,
        empleado: "Martín Torres",
        lunes: dia("N"),
        martes: franco(),
        miercoles: dia("N"),
        jueves: franco(),
        viernes: dia("N"),
        sabado: franco(),
        domingo: franco(),
    },
    {
        id: 9,
        empleado: "Sofía Ramírez",
        lunes: dia("T"),
        martes: dia("T"),
        miercoles: dia("T"),
        jueves: franco(),
        viernes: franco(),
        sabado: dia("M"),
        domingo: dia("M"),
    },
    {
        id: 10,
        empleado: "Pablo Herrera",
        lunes: dia("M"),
        martes: franco(),
        miercoles: dia("N"),
        jueves: dia("N"),
        viernes: franco(),
        sabado: dia("T"),
        domingo: franco(),
    },
    {
        id: 11,
        empleado: "Valentina Díaz",
        lunes: franco(),
        martes: dia("M"),
        miercoles: dia("M"),
        jueves: dia("M"),
        viernes: dia("M"),
        sabado: franco(),
        domingo: franco(),
    },
    {
        id: 12,
        empleado: "Mateo Castro",
        lunes: dia("N"),
        martes: dia("N"),
        miercoles: franco(),
        jueves: franco(),
        viernes: dia("N"),
        sabado: dia("N"),
        domingo: dia("N"),
    },
    {
        id: 13,
        empleado: "Camila Ruiz",
        lunes: dia("M"),
        martes: dia("T"),
        miercoles: dia("M"),
        jueves: dia("T"),
        viernes: dia("M"),
        sabado: franco(),
        domingo: franco(),
    },
    {
        id: 14,
        empleado: "Nicolás Vega",
        lunes: franco(),
        martes: franco(),
        miercoles: dia("T"),
        jueves: dia("T"),
        viernes: dia("T"),
        sabado: dia("T"),
        domingo: franco(),
    },
    {
        id: 15,
        empleado: "Julieta Morales",
        lunes: dia("M"),
        martes: dia("M"),
        miercoles: franco(),
        jueves: dia("M"),
        viernes: dia("M"),
        sabado: dia("M"),
        domingo: franco(),
    },
    {
        id: 16,
        empleado: "Tomás Silva",
        lunes: dia("T"),
        martes: dia("N"),
        miercoles: dia("T"),
        jueves: dia("N"),
        viernes: franco(),
        sabado: franco(),
        domingo: dia("M"),
    },
    {
        id: 17,
        empleado: "Florencia Ortiz",
        lunes: dia("M"),
        martes: dia("M"),
        miercoles: dia("M"),
        jueves: franco(),
        viernes: franco(),
        sabado: dia("T"),
        domingo: dia("T"),
    },
    {
        id: 18,
        empleado: "Lucas Benítez",
        lunes: dia("N"),
        martes: dia("N"),
        miercoles: dia("N"),
        jueves: dia("N"),
        viernes: dia("N"),
        sabado: franco(),
        domingo: franco(),
    },
];

/**
 * Guardias de ejemplo para TEx, por empleado.
 *
 * Son DISPERSAS a proposito: unas pocas por mes y no todos los dias, que es como se ve una
 * grilla de guardias de verdad. Varios empleados no tienen ninguna, para que se vea que una
 * fila vacia es un caso normal y no un error de carga.
 *
 * El dia es el numero del mes. Los que se pasen de los dias que tiene el mes se descartan, asi
 * febrero no rompe.
 */
const GUARDIAS_MOCK = {
    1: [{ dia: 3, codigo: "N" }, { dia: 11, codigo: "M/T" }, { dia: 24, codigo: "T" }],
    2: [{ dia: 7, codigo: "T/N" }, { dia: 18, codigo: "M" }],
    3: [{ dia: 2, codigo: "M" }, { dia: 9, codigo: "N/M" }, { dia: 16, codigo: "N" }, { dia: 27, codigo: "T" }],
    5: [{ dia: 14, codigo: "M/T" }],
    6: [{ dia: 5, codigo: "N" }, { dia: 21, codigo: "N" }],
    8: [{ dia: 10, codigo: "T" }, { dia: 23, codigo: "T/N" }],
    11: [{ dia: 1, codigo: "M" }, { dia: 19, codigo: "N/M" }, { dia: 30, codigo: "N" }],
    14: [{ dia: 6, codigo: "T" }],
    18: [{ dia: 12, codigo: "M/T" }, { dia: 26, codigo: "N" }],
};

// Alguna observacion suelta, para ver el puntito y el tooltip tambien en esta solapa.
const OBSERVACIONES_TEX = {
    "1-11": "Cubre a Gómez por licencia",
    "3-9": "Pasaje de guardia acordado",
};

/**
 * TURNOS EXTRAORDINARIOS (TEx), la otra solapa.
 *
 * Devuelve los mismos empleados con sus guardias del mes. `hospitalId` se recibe y se ignora,
 * igual que en el otro mock: el back va a filtrar por hospital cuando exista el service.
 *
 * Solo el mes ACTUAL trae guardias; los demas vienen vacios. Es el mismo criterio que el mock
 * de horarios, para que navegar entre meses se note.
 */
export const empleadosTExGet = async ({ hospitalId, mes }) => {
    await new Promise((resolve) => setTimeout(resolve, 150));
    const dias = getDiasDelMes(moment(`${mes}-01`));
    const esMesActual = mes === monthKey(moment());

    return empleadosHorariosMock.map((row) => {
        const rowMes = { id: row.id, empleado: row.empleado };
        if (!esMesActual) return rowMes;

        (GUARDIAS_MOCK[row.id] ?? []).forEach(({ dia, codigo }) => {
            const delDia = dias[dia - 1];
            if (!delDia) return; // el mes no llega a ese dia (febrero)
            rowMes[delDia.field] = {
                codigo,
                observacion: OBSERVACIONES_TEX[`${row.id}-${dia}`] ?? "",
            };
        });
        return rowMes;
    });
};

// Mock del guardado de TEx. Mismo formato de cambios que el de horarios.
export const empleadosTExSet = async ({ cambios }) => {
    console.log("empleadosTExSet (mock):", cambios);
    await new Promise((resolve) => setTimeout(resolve, 300));
    return { ok: true };
};

// Forma esperada del service real (todavía no existe):
// GET  → empleadosHorariosGet({ hospitalId, mes })  → rows con un campo "YYYY-MM-DD" por día del mes
// POST → empleadosHorariosSet({ cambios })          → status
export const USE_MOCK = true;

// Mock del guardado por lote. El service real va a recibir el mapa de cambios
// { "empleadoId-YYYY-MM-DD": { antes, despues } } y devolver un status.
export const empleadosHorariosSet = async ({ cambios }) => {
    console.log("empleadosHorariosSet (mock):", cambios);
    await new Promise((resolve) => setTimeout(resolve, 500));
    return { ok: true };
};

// Mock del service real. `hospitalId` se recibe pero se ignora por ahora:
// el back va a filtrar empleados por hospital cuando exista el service.
// Solo el mes actual devuelve horarios (expandiendo el patrón semanal de cada
// empleado sobre las fechas del mes); otros meses vienen vacíos.
export const empleadosHorariosGet = async ({ hospitalId, mes }) => {
    await new Promise((resolve) => setTimeout(resolve, 300));
    const dias = getDiasDelMes(moment(`${mes}-01`));
    const esMesActual = mes === monthKey(moment());
    const rows = empleadosHorariosMock.map((row) => {
        const rowMes = { id: row.id, empleado: row.empleado };
        dias.forEach(({ field }) => {
            const diaSemana = DIAS[moment(field).isoWeekday() - 1].key;
            rowMes[field] = esMesActual ? row[diaSemana] : franco();
        });
        return rowMes;
    });

    // Observaciones de ejemplo para ver el indicador y el tooltip en el mes actual.
    if (esMesActual && dias.length > 2) {
        const conHorario = rows[0][dias[1].field];
        rows[0][dias[1].field] = { ...conHorario, observacion: "Cubre la guardia de Sosa" };
        rows[3][dias[2].field] = { codigo: "L", observacion: "Parte médico presentado" };
    }

    return rows;
};
